import { FIRST_NAMES, FLAVOR_LINES, TITLES } from '../../data/heroNames';
import type { Hero, PersistentSave, RunState, WeaponType } from '../../types';
import { tierFor } from './Reputation';

const SILHOUETTE_POOL = ['knight', 'ranger', 'rogue'];

let heroCounter = 0;

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]!;
}

export interface HeroGenContext {
  run: RunState;
  save: PersistentSave;
}

/** Procedurally generates a hero based on the current rep tier + unlocked weapons. */
export function generateHero(ctx: HeroGenContext): Hero {
  const tier = tierFor(ctx.run.reputation);
  // HP scales with tier: more elite heroes have more HP (and harder enemies).
  const hpByTier: Record<typeof tier, number> = { low: 70, mid: 90, high: 110 };
  const maxHp = hpByTier[tier];

  // Weapon preference: pick from unlocked types, biased by tier.
  const unlocked = ctx.save.unlockedWeapons;
  const weaponPreference: WeaponType = pick(unlocked);

  const id = `hero_${Date.now().toString(36)}_${heroCounter++}`;
  return {
    id,
    name: pick(FIRST_NAMES),
    title: pick(TITLES),
    maxHp,
    hp: maxHp,
    silhouetteId: pick(SILHOUETTE_POOL),
    weaponPreference,
    urgency: Math.random() < 0.3 ? 'rushed' : 'patient',
    flavorLine: pick(FLAVOR_LINES),
  };
}
